/**
 * Theme Presets
 *
 * Pre-configured theme templates for common use cases.
 * All themes are now organized in individual files for better maintainability.
 */

// Import all theme presets
import { corporateProfessionalTheme } from './themes/corporateProfessional';
import { minimalistTheme } from './themes/minimalist';
import { forestZenTheme } from './themes/forestZen';
import { hotSpiceTheme } from './themes/hotSpice';
import { calmRelaxedTheme } from './themes/calmRelaxed';
import { darkEnergyTheme } from './themes/darkEnergy';

// Export individual themes with legacy naming for backward compatibility
export const CORPORATE_PROFESSIONAL_THEME = corporateProfessionalTheme;
export const MINIMALIST_THEME = minimalistTheme;
export const FOREST_ZEN_THEME = forestZenTheme;
export const HOT_SPICE_THEME = hotSpiceTheme;
export const CALM_RELAXED_THEME = calmRelaxedTheme;
export const DARK_ENERGY_THEME = darkEnergyTheme;

/**
 * All theme presets in the desired order
 * Order: Corporate Professional, Minimalist, Forest Zen,
 *        Hot & Spice, Calm & Relaxed, Dark Energy
 */
export const THEME_PRESETS = [
  CORPORATE_PROFESSIONAL_THEME,
  MINIMALIST_THEME,
  FOREST_ZEN_THEME,
  HOT_SPICE_THEME,
  CALM_RELAXED_THEME,
  DARK_ENERGY_THEME,
];

/**
 * Theme presets as object (for backward compatibility)
 */
export const THEME_PRESETS_MAP = {
  CORPORATE_PROFESSIONAL: CORPORATE_PROFESSIONAL_THEME,
  MINIMALIST: MINIMALIST_THEME,
  FOREST_ZEN: FOREST_ZEN_THEME,
  HOT_SPICE: HOT_SPICE_THEME,
  CALM_RELAXED: CALM_RELAXED_THEME,
  DARK_ENERGY: DARK_ENERGY_THEME,
};

/**
 * Get theme preset by name
 * @param {string} presetName - Name of the preset
 * @returns {object} Theme preset data
 */
export const getThemePreset = presetName => {
  return (
    THEME_PRESETS_MAP[presetName.toUpperCase().replace(/\s+/g, '_')] ||
    CORPORATE_PROFESSIONAL_THEME
  );
};

/**
 * Get all theme preset names
 * @returns {array} Array of preset names
 */
export const getThemePresetNames = () => {
  return THEME_PRESETS.map(preset => preset.theme_name);
};

/**
 * Get all theme presets as array
 * @returns {array} Array of theme preset objects
 */
export const getAllThemePresets = () => {
  return Object.values(THEME_PRESETS);
};

const presets = {
  CORPORATE_PROFESSIONAL_THEME,
  MINIMALIST_THEME,
  FOREST_ZEN_THEME,
  HOT_SPICE_THEME,
  CALM_RELAXED_THEME,
  DARK_ENERGY_THEME,
  THEME_PRESETS,
  THEME_PRESETS_MAP,
  getThemePreset,
  getThemePresetNames,
  getAllThemePresets,
};

export default presets;
